/**
 * Perform a full page load redirect.
 *
 * If in a React component, render `SmartRedirect` to perform redirects. It
 * handles full and client-side nav redirects correctly during rendering.
 *
 * Use this function from non-rendering code, non-React code or when
 * React Router-based non-rendered code navigation is insufficient.
 *
 * @param url The URL to redirect to.
 */
export const redirect = (url: string): void => {
    // If we're in storybook, raw redirects like this aren't so useful.
    // So instead, we log that it was requested and leave things where they are.
    if (process.env.STORYBOOK) {
        import(/* @vite-ignore */ "storybook/actions").then(({action}) => {
            action("redirect")(url);
        });
        return;
    }

    // Actually do the redirect.
    if (typeof window !== "undefined") {
        /* eslint-disable-next-line no-restricted-syntax
           --
           This is a permitted used of `window.location` access in our codebase.
           We need to be able to call the `assign` function here.
         */
        window.location?.assign?.(url);
    }
};
